var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPix = function SvgPix(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    style: {
      width: 56,
      transform: "rotate(0deg)",
      height: 56,
      background: "transparent"
    },
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.402 17.3a2.922 2.922 0 002.079-.86l2.998-2.999a.571.571 0 01.79 0l3.01 3.01a2.919 2.919 0 002.077.86h.592l-3.8 3.798a3.037 3.037 0 01-4.296 0L6.037 17.3h.36M17.356 6.688a2.917 2.917 0 00-2.077.862l-3.006 3.01a.56.56 0 01-.789 0L8.486 7.562a2.918 2.918 0 00-2.079-.86h-.37L9.852 2.89a3.038 3.038 0 014.296 0l3.8 3.798h-.592z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89 9.851l2.27-2.269h1.242c.545 0 1.067.216 1.454.6l2.999 2.998a1.44 1.44 0 002.038 0l3.011-3.01a2.07 2.07 0 011.454-.6h1.473l2.278 2.279a3.035 3.035 0 010 4.296l-2.279 2.28h-1.474a2.07 2.07 0 01-1.453-.6l-3.01-3.012a1.475 1.475 0 00-2.04 0L7.855 15.81a2.07 2.07 0 01-1.454.6H5.16l-2.27-2.263a3.035 3.035 0 010-4.297z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPix, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pix.4b1dbf05.svg";
export { ForwardRef as ReactComponent };